import { useNumericParams } from '@domain-group/react-hooks'

import useReduxAction from '@hooks/useReduxAction'

import { ModuleState } from '@redux/modules/types'

import TeamEditRoutes from './routes'

const TeamEdit = () => {
  const { teamId } = useNumericParams()

  useReduxAction(
    'teams',
    'loadTeam',
    {
      entityId: teamId,
    },
    [teamId],
    {
      dispatchAction: (action, requestOptions) => action(teamId, requestOptions),
      // @ts-expect-error TS2322
      shouldPerformFn: ({ loading }: ModuleState) => teamId && !loading,
    },
  )

  return (
    <TeamEditRoutes />
  )
}

export default TeamEdit
